module.exports = __webpack_public_path__ + "img/VsLotion5.61282511.jpg";